export const initialState = {
  rolesData: [],
  loadingSave: false,
  saveLoading: false,
  saveResponse: null,
  getRolePermissionData: [],
  tokenLoginData: [],
};
